import { getCreditCardNameByNumber } from "creditcard.js";


export const detectCard = (number) => {
    if (/^(5061|5060|5078|5079|650)/.test(number)) {
      return 'verve';
    }
  
    return getCreditCardNameByNumber(number);
  };
